import { trackEvent } from "./utils/helper-methods";

export async function addAnkiCard(
  selectedDeckToSaveCard: string,
  question: string,
  answer: string,
  userEmail: string | null,
  pageUrl: string | null,
  frontImageURL: string | null,
  backImageURL: string | null
) {
  let ankiCardId = null;
  let pictures = [];
  if (frontImageURL) {
    pictures.push({
      url: frontImageURL,
      filename: frontImageURL?.split("/").pop(),
      fields: ["Front"],
    });
  }
  if (backImageURL) {
    pictures.push({
      url: backImageURL,
      filename: backImageURL?.split("/").pop(),
      fields: ["Back"],
    });
  }

  try {
    ankiCardId = await invokeAnkiApi(
      "addNote",
      {
        note: {
          deckName: selectedDeckToSaveCard,
          modelName: "Basic",
          fields: {
            Front: question,
            Back: answer,
          },
          picture: pictures,
          options: {
            allowDuplicate: true,
          },
        },
      },
      userEmail
    );
  } catch (err) {
    console.log("Failed to add card to Anki Deck: ", err);
    ankiCardId = await invokeAnkiApi(
      "addNote",
      {
        note: {
          deckName: selectedDeckToSaveCard,
          modelName: "Basic",
          fields: {
            Front: question,
            Back: answer,
          },
          picture: pictures,
          options: {
            allowDuplicate: true,
          },
        },
      },
      userEmail
    );
    const ankiConnectVersion = await invokeAnkiApi("version", {}, userEmail);
    const modelNames = await invokeAnkiApi("modelNames", {}, userEmail);
    trackEvent("Error: Failed to add card to Anki Deck", {
      userEmail: userEmail,
      pageUrl: pageUrl,
      question: question,
      answer: answer,
      deckName: selectedDeckToSaveCard,
      errorMessage: err,
      ankiConnectVersion: ankiConnectVersion,
      modelNames: modelNames,
    });
    // console.log("Failed to add card to Anki Deck: ", err);
  }
  return ankiCardId;
}

export async function addMultipleAnkiCards(cards: any, userEmail: string | null) {
  let ankiCardIds = null;
  try {
    ankiCardIds = await invokeAnkiApi(
      "addNotes",
      {
        notes: cards,
      },
      userEmail
    );
  } catch (err) {
    console.log("Failed to add card to Anki Deck: ", err);
    ankiCardIds = await invokeAnkiApi(
      "addNotes",
      {
        notes: cards,
      },
      userEmail
    );
    trackEvent("Error: Failed to add cards to Anki Deck", cards);
  }
  return ankiCardIds;
}

export async function removeAnkiCard(ankiCardId: number, userEmail: string | null) {
  try {
    await invokeAnkiApi(
      "deleteNotes",
      {
        notes: [ankiCardId],
      },
      userEmail
    );
  } catch (err) {
    await invokeAnkiApi(
      "deleteNotes",
      {
        notes: [ankiCardId],
      },
      userEmail
    );
    console.log(err);
  }
}

// This is not being used but am keeping it here for now as reference
export async function getAllAnkiDecks(userEmail: string | null, pageUrl: string | null) {
  try {
    const responseDecks = await fetch("http://localhost:8765", {
      method: "POST",
      // set cors
      //   mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "deckNames",
        version: 6,
      }),
    });

    const responseObject = await responseDecks.json();
    // console.log("successs", responseObject);

    if (responseObject && responseObject.error) {
      trackEvent("Error: Failed to get Anki decks", {
        userEmail: userEmail,
        pageUrl: pageUrl,
        responseObject: responseObject,
        errorMessage: responseObject.error,
      });
    }
    return responseDecks;
  } catch (err) {
    trackEvent("Error: Failed to get Anki decks", {
      userEmail: userEmail,
      pageUrl: pageUrl,
      errorMessage: err,
    });
    // console.log("Error getting Anki decks:", err);
  }
}

export async function invokeAnkiApi(action: string, params = {}, userEmail: string | null) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener("error", (error) => {
      trackEvent("Error: Failed to invoke Anki API", {
        action: action,
        params: params,
        userEmail: userEmail,
        errorMessage: error,
      });
      reject(`failed to issue request: ${error}`);
    });
    xhr.addEventListener("load", () => {
      try {
        const response = JSON.parse(xhr.responseText);
        if (action !== "addNote") {
          if (Object.getOwnPropertyNames(response).length !== 2) {
            throw new Error("response has an unexpected number of fields");
          }
          if (!response.hasOwnProperty("error")) {
            throw new Error("response is missing required error field");
          }
          if (!response.hasOwnProperty("result")) {
            throw new Error("response is missing required result field");
          }
        }
        if (action === "addNote") {
          resolve(response);
        }
        if (response.error) {
          throw response.error;
        }
        resolve(response.result);
      } catch (err) {
        console.log("error in response err:", err);
        trackEvent("Error: Failed to invoke Anki API", {
          action: action,
          params: params,
          userEmail: userEmail,
          errorMessage: err,
        });
        reject(err);
      }
    });

    xhr.open("POST", "http://127.0.0.1:8765");
    if (action === "addNote") {
      xhr.send(JSON.stringify({ action, params }));
    } else {
      xhr.send(JSON.stringify({ action, version: 6, params }));
    }
  });
}
